// extracted by mini-css-extract-plugin
export default {"bordered":"bordered_bordered__uU7OW","bordered-thick":"bordered_bordered-thick__6ctHd"};